import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import * as React from 'react'
type ConfirmPopupProps = {
  open: boolean
  submitTitle: string
  isError: boolean
  handleClose: () => void
  handleConfirmSubmitClick: () => void
  children?: React.ReactNode
}
export const ConfirmPopup = ({
  open,
  submitTitle,
  isError,
  handleClose,
  handleConfirmSubmitClick,
  children
}: ConfirmPopupProps) => {
  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">{submitTitle}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>

        {isError ? (
          <></>
        ) : (
          <Button variant="contained" onClick={handleConfirmSubmitClick}>
            Submit
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
